const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

// Backend de multiproductos corre en 8020 en desarrollo (8010 ya lo usa
// el proyecto hermano "restaurant" en esta misma maquina).
export const PATH = isLocal
    ? `http://${window.location.hostname}:8020`
    : `https://${window.location.hostname}/api`;

export const WS_PATH = isLocal
    ? `ws://${window.location.hostname}:8020`
    : `wss://${window.location.hostname}`;
